import httpClient from '../httpClient';
const email = async (data) => {
  return await httpClient.post(`${process.env.REACT_APP_API_HOST}/users/email/`, data);
};

export {
  email
};
